module.exports = __webpack_public_path__ + "static/media/UPGCatalogBannerZoomed-sm.6297d999.jpg";